import { NavLink, Outlet } from 'react-router-dom';

import { useWorkspace } from '@/_shared/contexts/WorkspaceContext';
import { cn } from '@/_shared/lib/utils';

const TAB_PATHS = [
  { path: '/settings', label: 'General', end: true },
  { path: '/settings/scm', label: 'SCM', end: false },
  { path: '/settings/sources', label: 'Sources', end: false },
  { path: '/settings/warehouse', label: 'Warehouse', end: false },
  { path: '/settings/integrations', label: 'Integrations', end: false },
  { path: '/settings/slack', label: 'Slack', end: false },
  { path: '/settings/members', label: 'Members', end: false },
] as const;

export function SettingsShell(): React.ReactElement {
  const { wp } = useWorkspace();

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <div className="border-b border-border/80 bg-white/75 px-6 py-6 backdrop-blur-sm md:px-8">
        <p className="text-[0.6875rem] font-semibold tracking-[0.18em] text-muted-foreground uppercase">
          Workspace Settings
        </p>
        <div className="mt-2">
          <h1 className="text-2xl font-semibold tracking-[-0.03em] text-foreground">Settings</h1>
          <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
            Configure RudderStack access, repository mappings, integrations, and workspace membership from one shared
            control plane.
          </p>
        </div>
        <nav className="mt-6 flex flex-wrap items-center gap-2">
          {TAB_PATHS.map((tab) => (
            <NavLink
              key={tab.path}
              to={wp(tab.path)}
              end={tab.end}
              className={({ isActive }) =>
                cn(
                  'rounded-full border px-4 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'border-primary/15 bg-primary/10 text-primary'
                    : 'border-border/80 bg-white/70 text-muted-foreground hover:border-primary/20 hover:text-foreground',
                )
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="flex-1 overflow-y-auto px-6 py-6 md:px-8 md:py-8">
        <div className="max-w-3xl">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
